import { z } from "zod";

export const TovChunkResponseSchema = z.object({
  id: z.uuid(),
  sourceId: z.uuid(),
  parsedPageId: z.uuid().nullable(),
  chunkIndex: z.number().int(),
  sectionPath: z.string().nullable(),
  content: z.string(),
  contentHash: z.string(),
  pageStart: z.number().int().nullable(),
  pageEnd: z.number().int().nullable(),
  tokenCount: z.number().int(),
  createdAt: z.iso.datetime(),
});
export type TovChunkResponse = z.infer<typeof TovChunkResponseSchema>;

export const TovEmbeddingResponseSchema = z.object({
  id: z.uuid(),
  chunkId: z.uuid(),
  provider: z.string(),
  model: z.string(),
  dimensions: z.number().int(),
  createdAt: z.iso.datetime(),
});
export type TovEmbeddingResponse = z.infer<typeof TovEmbeddingResponseSchema>;

export const TovEmbeddingListResponseSchema = z.object({
  embeddings: z.array(TovEmbeddingResponseSchema),
});
export type TovEmbeddingListResponse = z.infer<
  typeof TovEmbeddingListResponseSchema
>;

export const TovEvidenceResponseSchema = z.object({
  id: z.uuid(),
  versionId: z.uuid(),
  sourceId: z.uuid(),
  chunkId: z.uuid().nullable(),
  parsedPageId: z.uuid().nullable(),
  locator: z.string(),
  claim: z.string(),
  createdAt: z.iso.datetime(),
});
export type TovEvidenceResponse = z.infer<typeof TovEvidenceResponseSchema>;

export const TovDefinitionEvidenceResponseSchema = z.object({
  id: z.uuid(),
  versionId: z.uuid(),
  evidenceId: z.uuid(),
  targetTable: z.string(),
  targetId: z.uuid(),
  targetField: z.string(),
  relationship: z.string(),
  confidence: z.number().int().nullable(),
  createdAt: z.iso.datetime(),
  evidence: TovEvidenceResponseSchema,
});
export type TovDefinitionEvidenceResponse = z.infer<
  typeof TovDefinitionEvidenceResponseSchema
>;

export const TovChunkListResponseSchema = z.object({
  chunks: z.array(TovChunkResponseSchema),
});
export type TovChunkListResponse = z.infer<typeof TovChunkListResponseSchema>;
